__turbopack_context__.v({
  "actions": "ComponentOverviewHit-Diagram-module-scss-module__BBb5Ta__actions",
  "root": "ComponentOverviewHit-Diagram-module-scss-module__BBb5Ta__root",
});
